module.exports = __webpack_public_path__ + "static/media/young7_s.a6edaa0b.jpg";